// extracted by mini-css-extract-plugin
export default {"description":"N+eAucUCVcG+0b6NLPyO-Q=="};